import {ChangeDetectorRef, Component, Input, OnDestroy} from '@angular/core';
import {ThingActivatorsInterface} from '@app/app/shared/interfaces/thing/thing-activator.interface';
import {CommandsService} from '@app/app/shared/services/commands.service';
import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';

@Component({
  templateUrl: './park-activator-control.html',
  selector: 'park-activator-control'
})

export class ParkActivatorControlComponent implements OnDestroy {
  @Input() public activator: ThingActivatorsInterface;
  @Input() public activatorId: string;
  @Input() public parkId: string;
  @Input() public id: string;

  public isRunningAuto = false;
  public isRunningManual = false;
  public isRunningOff = false;

  private timerSub: Subscription;

  private MODE_AUTO = 'auto';
  private MODE_MANUAL = 'manu';
  private MODE_OFF = 'off';

  constructor(private comm: CommandsService, private cdRef: ChangeDetectorRef) {
    //
  }

  public values(obj: object) {
    return Object.values(obj);
  }

  /**
   * Set mode to auto
   */
  public setModeAuto() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningAuto = true;
      this.update(this.MODE_AUTO);
    }
  }

  /**
   * Set mode to manual
   */
  public setModeManual() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningManual = true;
      this.update(this.MODE_MANUAL);
    }
  }

  /**
   * Set mode to off
   */
  public setModeOff() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningOff = true;
      this.update(this.MODE_OFF);
    }
  }

  public isAuto() {
    const isAuto = (this.activator.md === this.MODE_AUTO);

    if (isAuto && this.isRunningAuto) {
      this.isRunningAuto = false;
      this.cdRef.detectChanges();
    }

    return isAuto;
  }

  public isManual() {
    const isManual = (this.activator.md === this.MODE_MANUAL);

    if (isManual && this.isRunningManual) {
      this.isRunningManual = false;
      this.cdRef.detectChanges();
    }

    return isManual;
  }

  public isOff() {
    const isOff = (this.activator.md === this.MODE_OFF);

    if (isOff && this.isRunningOff) {
      this.isRunningOff = false;
      this.cdRef.detectChanges();
    }

    return isOff;
  }

  public isRunning() {
    return (this.isRunningAuto || this.isRunningManual || this.isRunningOff);
  }

  /**
   * Update activator
   */
  private update(mode: string) {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }

    this.comm.setActivatorMode(this.parkId, this.id, this.activatorId, mode).then((res) => {
      this.timerSub = Observable.of(true).delay(8000).subscribe(() => {
        if (this.isRunningAuto && !this.isAuto()) {
          alert('Timed Out');
        }

        if (this.isRunningManual && !this.isManual()) {
          alert('Timed Out');
        }

        if (this.isRunningOff && !this.isOff()) {
          alert('Timed Out');
        }

        [this.isRunningAuto, this.isRunningManual, this.isRunningOff] = [false, false, false];
      });
    }).catch((err) => {
      [this.isRunningAuto, this.isRunningManual, this.isRunningOff] = [false, false, false];

      alert(err);
    });
  }

  ngOnDestroy() {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/controls/features/activators/control/park-activator-control.component.ts